import {
  Box,
  Button,
  Center,
  Checkbox,
  Divider,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Select,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { color } from "../../../utils/theme";
import LevelList from "./levellist";
import "./styles.css";
import Title from "../../../components/Title";
import { useNavigate } from "react-router-dom";
import DataTableBase from "../../../components/data-table/data-table";
import { TableColumn } from "react-data-table-component";
import { Role } from "../../../redux/reducer/roleReducer";
import { Menu } from "../../../redux/reducer/menuReducer";
import { Permission } from "../../../redux/reducer/permissionReducer";
import {
  addRole,
  getMenus,
  getPermissions,
  getRoles,
  updateRole,
} from "./roleService";
import FormInput from "../../../components/input";
import { addDataEntry } from "../DataEntry/dataEntryService";
import { FaPlusCircle } from "react-icons/fa";

const RoleManagement = () => {
  const [activeTabId, setActiveTabId] = useState<string>("");
  const [rows, setRows] = useState<any[]>([]);
  const [pending, setPending] = useState(false);
  const [rawPermissions, setRawPermissions] = useState<Permission[]>([]);
  const [roleCode, setRoleCode] = useState("");
  const [rawMenus, setRawMenus] = useState<Menu[]>([]);
  const [selectedLevel, setSelectedLevel] = useState("");
  const [uniqueLevels, setUniqueLevels] = useState<string[]>([]);
  const [levels, setLevels] = useState<{
    [key: string]: { name: string; level: string }[];
  }>({});
  const [menuRows, setMenuRows] = useState<
    { id: number; name: string; isEnabled: boolean }[]
  >([]);
  const [permissionRowSets, setPermissionRowSets] = useState<
    { id: number; name: string; group: string; isEnabled: boolean }[][]
  >([]);
  const [permissionRows, setPermissionRows] = useState<
    { id: number; name: string; isEnabled: boolean }[]
  >([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [roles, setRoles] = useState<Role[]>([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [payloadPermissions, setPayloadPermission] = useState<Permission[]>([]);
  const [payloadMenus, setPayloadMenus] = useState<Menu[]>([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [filterdPermssions, setFilterdPermssions] = useState<Permission[]>([]);
  const [filterdMenus, setFilteredMenus] = useState<Menu[]>([]);
  const [showMenus, setShowMenus] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [roleID, setRoleID] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);
  const [roleName, setRoleName] = useState("");
  const [roleLevel, setRoleLevel] = useState("");
  const [addRoleLoading, setAddRoleLoading] = useState(false);
  const toast = useToast();

  function btnClick(selectedLevel: string, selectedRole: string, id: any) {
    console.log("clicked role: ", selectedLevel, selectedRole, id);
    setSelectedLevel(selectedLevel);
    setSelectedRole(selectedRole);
    setRoleID(roles.filter((role) => role.name === selectedRole)[0].id);
    let filterdRole = roles.filter((role) => role.name === selectedRole);
    let rolePermissions = filterdRole[0].permissions;
    let roleMenus = filterdRole[0].menus;
    setFilterdPermssions(rolePermissions);
    setFilteredMenus(roleMenus);
    setActiveTabId(id);
  }

  let filterdRoles: { role: string; menus: any[]; permissions: any[] }[] = [];

  const fetchRoles = async () => {
    try {
      const data = await getRoles();
      console.log("role data", data);

      const levelRoles = data.map((role: Role) => ({
        name: role.name,
        level: role.level,
      }));

      let filterdLevels:string[] = Array.from(
        new Set(levelRoles.map((role: Role) => role.level))
      );
      console.log("uniqueLevels: ", uniqueLevels);
      
      const groupedRoles = levelRoles.reduce(
        (
          acc: { [key: string]: { name: string; level: string }[] },
          role: { level: any; name: any }
        ) => {
          const level = role.level;
          if (!acc[level]) {
            acc[level] = [];
          }
          if (!acc[level].some((r) => r.name === role.name)) {
            acc[level].push(role);
          }
          return acc;
        },
        {}
      );

      filterdRoles = roles
        .filter((role, index) => {
          return role.name === selectedRole;
        })
        .map((role, index) => {
          return {
            role: role.name,
            menus: role.menus,
            permissions: role.permissions,
          };
        });

      console.log("filterdRoles: ", filterdRoles);

      setLevels(groupedRoles);
      console.log("keys: ", Object.keys(groupedRoles));
      setUniqueLevels(filterdLevels);
      
      setRoles(data);
    } catch (error) {
      setError("Failed to fetch Roles");
      console.error(error);
    }
  };

  const fetchPermissions = async () => {
    try {
      const data = await getPermissions();
      setRawPermissions(data);
      setPermissionRows(
        data.map((permission: Permission) => ({
          id: permission.id,
          name: permission.name,
          group: permission.group,
          isEnabled: filterdRoles.some((role) =>
            role.permissions.some((perm) => perm.id === permission.id)
          ),
        }))
      );

      const groupedPermissions = data.reduce(
        (
          acc: { [key: string]: PermissionDataRow[] },
          permission: Permission
        ) => {
          const group = permission.group;
          if (!acc[group]) {
            acc[group] = [];
          }
          acc[group].push({
            id: permission.id,
            name: permission.name,
            group: permission.group,
            isEnabled: filterdRoles.some((role) =>
              role.permissions.some((perm) => perm.id === permission.id)
            ),
          });
          return acc;
        },
        {}
      );

      console.log("groupedPermissions", groupedPermissions);
      setPermissionRowSets(Object.values(groupedPermissions));
    } catch (error) {
      setError("Failed to fetch permissions");
      console.error(error);
    }
  };

  const fetchMenus = async () => {
    try {
      const data = await getMenus();
      console.log("raw roles: ", data);
      console.log("filterd role: ", filterdRoles);
      setRawMenus(data);
      const menuRow = data.map((menu: Menu) => ({
        id: menu.id,
        name: menu.name,
        isEnabled: filterdRoles.some((role) =>
          role.menus.some((data) => data.id === menu.id)
        ),
      }));
      setMenuRows(menuRow);
      console.log("menuRow", menuRow);
    } catch (error) {
      setError("Failed to fetch Menus");
      console.error(error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchRoles().then(() => {
      fetchPermissions();
      fetchMenus();
    });

    setIsLoading(false);
  }, [selectedLevel, selectedRole, refreshTable]);

  useEffect(() => {
    setIsLoading(true);
    setPayloadPermission([]);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    console.log("refreshing table");

    setIsLoading(true);
    setPayloadPermission([]);
    setIsLoading(false);
  }, []);

  const navigate = useNavigate();

  type PermissionDataRow = {
    id: number;
    name: string;
    group: string;
    isEnabled: boolean;
  };

  type MenuDataRow = {
    id: number;
    name: string;
    isEnabled: boolean;
  };

  const updatePermission = (checked: boolean, id: number) => {
    setIsLoading(true);
    setTimeout(() => {
      let newPermissions;
      if (
        checked === true &&
        !filterdPermssions.some((perm) => perm.id === id)
      ) {
        const permissionToAdd = rawPermissions.find((perm) => perm.id === id);
        if (permissionToAdd) {
          newPermissions = [...filterdPermssions, permissionToAdd];
          setFilterdPermssions(newPermissions);
          setPayloadPermission(newPermissions);
        }
      } else {
        newPermissions = filterdPermssions.filter((perm) => perm.id !== id);
        setFilterdPermssions(newPermissions);
        setPayloadPermission(newPermissions);
      }

      const updatedPermissions = permissionRows.map((permission) =>
        permission.id === id
          ? { ...permission, isEnabled: checked }
          : permission
      );

      setPermissionRows(updatedPermissions);

      const updatedPermissionRowSets = permissionRowSets.map((set) =>
        set.map((permission) =>
          permission.id === id
            ? { ...permission, isEnabled: checked }
            : permission
        )
      );
      setPermissionRowSets(updatedPermissionRowSets);
      // Check if there are any changes
      const hasChanges =
        JSON.stringify(newPermissions) !==
        JSON.stringify(
          roles.filter((role) => role.name === selectedRole)[0].permissions
        );
      console.log("hasChanges: ", hasChanges);
      setHasChanges(hasChanges);

      setIsLoading(false);
    }, 1500);
  };

  const saveChanges = () => {
    console.log("Permissions to save: ", payloadPermissions);
    console.log(
      "Menus to save: ",
      payloadMenus.map((menu) => menu.id)
    );

    console.log("Role ID: ", roleID);
    console.log("Menus to save: ", showMenus);

    setIsSubmitting(true);
    updateRole({
      id: roleID,
      permissions: showMenus ? filterdPermssions : payloadPermissions,
      menuIds: showMenus ? payloadMenus.map((menu) => menu.id) : filterdMenus,
    })
      .then((response) => {
        console.log("Response: ", response);
        if (response) {
          toast({
            position: "top-right",
            render: () => (
              <Box color="white" p={3} bg="green" borderRadius={4}>
                Changes saved successfully!
              </Box>
            ),
          });
          setRefreshTable(!refreshTable);
        } else {
          toast({
            position: "top-right",
            render: () => (
              <Box color="white" p={3} bg="red" borderRadius={4}>
                Failed to save changes!
              </Box>
            ),
          });
        }
        setIsSubmitting(false);
        setRefreshTable(!refreshTable);
      })
      .catch((error) => {
        console.error("Failed to save changes:", error);
        toast({
          position: "top-right",
          render: () => (
            <Box color="white" p={3} bg="red" borderRadius={4}>
              Failed to save changes!
            </Box>
          ),
        });
        setIsSubmitting(false);
      });

    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setRefreshTable(!refreshTable);
    }, 1500);
  };

  //TODO @primeKal am passing the menu ids but the api isn't updating the menus
  const updateMenu = (checked: boolean, id: number) => {
    setIsLoading(true);
    setTimeout(() => {
      let newMenus;
      if (checked === true && !filterdMenus.some((menu) => menu.id === id)) {
        const menusToAdd = rawMenus.find((menu) => menu.id === id);
        if (menusToAdd) {
          newMenus = [...filterdMenus, menusToAdd];
          setFilteredMenus(newMenus);
          setPayloadMenus(newMenus);
        }
      } else {
        newMenus = filterdMenus.filter((menu) => menu.id !== id);
        setFilteredMenus(newMenus);
        setPayloadMenus(newMenus);
      }

      const updatedMenus = menuRows.map((menu) =>
        menu.id === id ? { ...menu, isEnabled: checked } : menu
      );

      setMenuRows(updatedMenus);

      // Check if there are any changes
      const hasChanges =
        JSON.stringify(newMenus) !==
        JSON.stringify(
          roles.filter((role) => role.name === selectedRole)[0].menus
        );
      console.log("hasChanges: ", hasChanges);
      setHasChanges(hasChanges);

      setIsLoading(false);
    }, 1500);
  };

  const permissionColumns: TableColumn<PermissionDataRow>[] = [
    {
      name: "Permission",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Active",
      selector: (row) => row.isEnabled,
      cell: (row) => (
        <Checkbox
          isChecked={row.isEnabled}
          isDisabled={isLoading}
          onChange={(e) => updatePermission(e.target.checked, row.id)}
        />
      ),
      sortable: true,
    },
  ];

  const menuColumns: TableColumn<MenuDataRow>[] = [
    {
      name: "Menu",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Active",
      selector: (row) => row.isEnabled,
      cell: (row) => (
        <Checkbox
          isChecked={row.isEnabled}
          isDisabled={isLoading}
          onChange={(e) => updateMenu(e.target.checked, row.id)}
        />
      ),
      sortable: true,
    },
  ];

  return (
    <Center>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Role</ModalHeader>
          <ModalCloseButton />
          <ModalBody sx={{ display: "flex", gap: 3, flexDirection: "column" }}>
            <>
              <FormInput
                name="roleName"
                isRequired={true}
                value={roleName}
                label="Role Name"
                type="text"
                id="name"
                errorMessage={roleName === "" ? "Role Name is required" : ""}
                onChange={(event) => {
                  setRoleName(event.target.value);
                }}
              />
            </>
            <>
              <FormLabel
                alignSelf={"flex-start"}
                display={"flex"}
                mb={-4}
               
                pb={0}
                justifyContent={"left"}
                alignContent={"flex-start"}
                alignItems={"flex-start"}
                textAlign={"left"}
                fontWeight={"500"}
                color={"black"}
              >
                Role Level
                <Text color={"red"} mx={1} fontSize={24}>
                  *
                </Text>
              </FormLabel>
              <Select
                placeholder="Select Level"
                onChange={(event) => {
                  setRoleLevel(event.target.value);
                }}
                mt={0}
                pt={0}
              >
                {uniqueLevels.map((level, index) => (
                  <option key={`${level}-${index}`} value={level}>
                    {level.toUpperCase()}
                  </option>
                ))}
              </Select>
              {roleLevel === "" && (
                <Text mt={2} color="red.500" fontSize="sm">
                  Role Level is required.
                </Text>
              )}
            </>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              isLoading={addRoleLoading}
              isDisabled={
                roleName === "" || roleLevel === "" 
              }
              mr={3}
              onClick={async () => {
                setAddRoleLoading(true);
                const payload = {
                  name: roleName,
                  level: roleLevel,
                  code: roleCode,
                };
                const response = await addRole(payload);
                if (response) {
                  console.log(response.data);
                  setAddRoleLoading(false);
                  onClose();
                  toast({
                    position: "top-right",
                    render: () => (
                      <Box color="white" p={3} bg="green">
                        Role Added Successfully
                      </Box>
                    ),
                  });
                  setRefreshTable(!refreshTable);
                } else {
                  setAddRoleLoading(false);
                  toast({
                    position: "top-right",
                    render: () => (
                      <Box color="white" p={3} bg="red">
                        Something went wrong!, try again
                      </Box>
                    ),
                  });
                }
              }}
              w={"100%"}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <VStack
        w={"90%"}
        textAlign={"left"}
        alignContent={"flex-start"}
        alignItems={"flex-start"}
      >
        <HStack w={"100%"} justifyContent={"space-between"}>
          <Title title={"Role Management"} onClick={() => navigate("/")} />
          <Button
            colorScheme="blue"
            fontWeight={"bold"}
            fontSize={"md"}
            size={"lg"}
            leftIcon={<FaPlusCircle/>}
            onClick={() => {
              onOpen();
            }}
            ml={"auto"}
          >
            Add Role
          </Button>
        </HStack>
        <Divider mb={4} />
        <HStack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignContent={"flex-start"}
          alignItems={"flex-start"}
          w={"100%"}
          gap={20}
        >
          <Box flex={0.3}>
            <VStack textAlign={"left"} gap={5}>
              <Box boxShadow={"md"} w={"100%"}>
                <ul className="section__Jobs-styledTabList">
                  {Object.keys(levels).map((level, index) => (
                    <React.Fragment key={level}>
                      <Text textAlign={"left"} py={2} bg={"gray.100"} px={2}>
                        {level}
                      </Text>
                      {levels[level].map((role, roleIndex) => (
                        <LevelList
                          key={roleIndex + role.name}
                          onClick={() => {
                            setSelectedLevel(level);
                            btnClick(
                              role.level,
                              role.name,
                              roleIndex + role.name
                            );
                          }}
                          data={role.name}
                          index={roleIndex + role.name}
                          activeTabId={activeTabId}
                        />
                      ))}
                    </React.Fragment>
                  ))}
                </ul>
              </Box>
              <Divider />
            </VStack>
          </Box>
          {/* {!isLoading && ( */}

          <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Button
              colorScheme="blue"
              fontWeight={"bold"}
              isLoading={isSubmitting}
              isDisabled={!hasChanges}
              fontSize={"md"}
              my={2}
              onClick={() => {
                saveChanges();
              }}
              ml={"auto"}
            >
              Save Changes
            </Button>

            <Tabs isFitted variant={"enclosed"}>
              <TabList fontWeight={"bold"}>
                <Tab
                  fontWeight={"bold"}
                  onClick={() => {
                    setShowMenus(false);
                  }}
                >
                  Permission
                </Tab>
                <Tab
                  onClick={() => {
                    setShowMenus(true);
                  }}
                  fontWeight={"semi-bold"}
                >
                  Menu
                </Tab>
              </TabList>
              {isLoading && <Progress size="xs" isIndeterminate />}
              <TabPanels>
                <TabPanel>
                  {permissionRowSets.map((permissionSet, index) => (
                    <VStack key={index} textAlign={"left"} gap={0} mt={2}>
                      <Text
                        fontSize={15}
                        textAlign={"left"}
                        p={4}
                        bg={"gray.100"}
                        w={"100%"}
                        fontWeight={"bold"}
                        borderBottom={"1px solid #ccc"}
                      >
                        {permissionSet[0].group}
                      </Text>

                      <DataTableBase
                        columns={permissionColumns}
                        data={permissionSet}
                        progressPending={pending}
                        progressComponent={
                          <Box
                            mt={20}
                            display={"flex"}
                            flexDirection={"column"}
                            justifyContent={"center"}
                            alignContent={"center"}
                            alignItems={"center"}
                            gap={4}
                          >
                            <Spinner
                              title="Getting existing challenges"
                              color={color.primary}
                            />
                            <Text color={color.text} fontSize={16}>
                              Fetching Users
                            </Text>
                          </Box>
                        }
                        dense
                        pagination={false}
                      />
                    </VStack>
                  ))}
                </TabPanel>
                <TabPanel>
                  <DataTableBase
                    columns={menuColumns}
                    data={menuRows}
                    progressPending={pending}
                    progressComponent={
                      <Box
                        mt={20}
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                        alignContent={"center"}
                        alignItems={"center"}
                        gap={4}
                      >
                        <Spinner title="Getting menus" color={color.primary} />
                        <Text color={color.text} fontSize={16}>
                          Fetching Menus
                        </Text>
                      </Box>
                    }
                    dense
                    pagination={false}
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
          {/* )} */}
        </HStack>
      </VStack>
    </Center>
  );
};

export default RoleManagement;
